module.exports = __webpack_public_path__ + "7a041840bef78f0152ba5cfe519ac07d.png";